import { create } from 'zustand'

import type { WsConnectionState } from '@/types/websocket'

interface WebSocketStore {
  connectionState: WsConnectionState
  reconnectAttempt: number
  setStatus: (state: WsConnectionState, attempt?: number) => void
  reset: () => void
}

export const useWebSocketStore = create<WebSocketStore>((set) => ({
  connectionState: 'DISCONNECTED',
  reconnectAttempt: 0,
  setStatus: (connectionState, reconnectAttempt = 0) =>
    set({ connectionState, reconnectAttempt }),
  reset: () =>
    set({
      connectionState: 'DISCONNECTED',
      reconnectAttempt: 0,
    }),
}))
